<template>
    <div>
        <v-container grid-list-md justify-start>
            <v-layout>
                <v-flex xs12>
                    <div class="title mb-2">Rosters</div>
                    <v-divider></v-divider>
                </v-flex>
            </v-layout>
        </v-container>

        <rosters-grid v-bind:rosters="rosters_season"></rosters-grid>
    </div>
</template>

<script>
import RostersGrid from './RostersGrid'

export default {
    name: 'Rosters',
    components: {
        RostersGrid
    },
    computed: {
        rosters_season() {
            return this.$store.getters.getRostersBySelectedSeason
        }
    }
}
</script>

<style scoped></style>
